import isNil from './isNil';

export default function isObjectEmpty(obj) {
  if (isNil(obj)) {
    return true;
  }
  if (typeof obj === 'object') {
    return isObjectEmpty(obj);
  }

  return false;

  function isObjectEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
}
